'use client'

import {
  createContext,
  type FC,
  type PropsWithChildren,
  useContext,
} from 'react'

import { type GkAirConfiguration } from '../../config/gkAirGetConfiguration.ts'

const Context = createContext<GkAirConfiguration | undefined>(undefined)

export const useGkAirConfigContext = (): GkAirConfiguration => {
  const contextValue = useContext(Context)

  if (contextValue === undefined) {
    throw new Error('Gk Air config provider unavailable')
  }

  return contextValue
}

type GkAirConfigProviderProps = {
  value: GkAirConfiguration
}

export const GkAirConfigProvider: FC<
  PropsWithChildren<GkAirConfigProviderProps>
> = ({ children, value }) => (
  <Context.Provider value={value}>{children}</Context.Provider>
)
